const requestUpdateMatchingSubscriptions = ({
  requestUpdateMultipleSubscriptions,
  allSubscriptions,
  currentSubscriptionId,
  newPaymentInstrumentId,
}) => {
  const currentSubscription = allSubscriptions.find(
    (subscription) => subscription.Id === currentSubscriptionId,
  );
  const oldPaymentInstrumentId = currentSubscription?.PaymentInstrument?.Id;

  const subscriptionsToUpdate = allSubscriptions.filter(
    (subscription) =>
      subscription?.PaymentInstrument?.Id === oldPaymentInstrumentId,
  );
  const updateRequests = [];
  subscriptionsToUpdate.forEach((subscription) => {
    if (subscription.Id === currentSubscriptionId) {
      updateRequests.push({
        Id: subscription?.Id,
        PaymentInstrumentId: newPaymentInstrumentId,
        Renew: true,
      });
    } else {
      updateRequests.push({
        Id: subscription?.Id,
        PaymentInstrumentId: newPaymentInstrumentId,
      });
    }
  });
  requestUpdateMultipleSubscriptions(updateRequests);
};

export { requestUpdateMatchingSubscriptions };
export default requestUpdateMatchingSubscriptions;
